import type { ElementType, ReactNode } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

export interface StatusItemProps {
  icon?: ElementType;
  children: ReactNode;
  tooltip?: string;
  className?: string;
  onClick?: () => void;
  highlight?: boolean;
}

/**
 * Compact status indicator used in the application footer / status bar.
 */
export function StatusItem({ icon: Icon, children, tooltip, className, onClick, highlight }: StatusItemProps) {
  const content = (
    <button
      className={cn(
        "flex items-center gap-1.5 px-2 py-1 text-xs rounded-sm transition-colors",
        "hover:bg-primary/10 dark:hover:bg-white/10",
        onClick ? "cursor-pointer" : "cursor-default",
        highlight && "bg-primary/10 dark:bg-sopho-entity/20",
        className,
      )}
      onClick={onClick}
      type="button"
    >
      {Icon && <Icon className="h-3.5 w-3.5" />}
      {children}
    </button>
  );

  if (tooltip) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>{content}</TooltipTrigger>
          <TooltipContent side="top" className="text-xs">
            <p>{tooltip}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return content;
}
